import React from 'react';
import { Box } from '@mui/material';
import { connect, type ConnectedProps } from 'react-redux';
import { currentDailyMatches } from '@/slices/matches';
import { type RootState } from '@/store';
import SidebarMenu from '../SidebarMenu';
import LiveEditors from '../LiveEditors';
import LiveBlogEvents from '../LiveBlogEvents';
import styles from './styles';

type SidebarItem = {
  path: string;
  label: string;
  icon: React.ReactNode;
};

type SidebarProps = {
  items?: SidebarItem[];
  events?: boolean;
  liveEditors?: boolean;
  mode?: 'light' | 'dark';
} & ConnectedProps<typeof connector>;

const Sidebar = ({
  items,
  events,
  liveEditors,
  mode,
  currentDailyMatches,
}: SidebarProps) => {
  const rootStyle = mode === 'light' ? styles.lightRoot : styles.darkRoot;

  const currentEvents = currentDailyMatches
    ?.filter((match) => match?.event)
    ?.map((match) => ({
      author: `${match.home_team.name} - ${match.away_team.name}`,
      title: match?.event?.name || '',
      status: match?.event?.status.name || '',
      slug: match?.event?.slug || '',
    }));

  return (
    <Box sx={[styles.root, rootStyle]}>
      {items && <SidebarMenu items={items} />}
      {liveEditors && <LiveEditors users={3} />}
      {events && <LiveBlogEvents events={currentEvents} />}
    </Box>
  );
};

const connector = connect((state: RootState) => ({
  currentDailyMatches: currentDailyMatches(state),
}));

export default connector(Sidebar);
